import React, { Component } from "react";
import "./Badge.css";
import config from "./config";

class Badge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatbotlang:
        !this.props.chatbotlang || typeof this.props.chatbotlang === "undefined"
          ? "ar"
          : this.props.chatbotlang,
      bottom: undefined,
    };
  }

  async componentDidMount() {
    await this.setState({ bottom: -64 });
    while (this.state.bottom < 15) {
      await new Promise((resolve) => setTimeout(resolve, 1));
      await this.setState((state) => ({ bottom: state.bottom + 1 }));
    }
  }

  componentDidUpdate() {
    let oldlang = this.state.chatbotlang;
    let newlang =
      !window.chatbotlang || typeof window.chatbotlang === "undefined"
        ? "ar"
        : window.chatbotlang;

    if (oldlang !== newlang) {
      this.setState({ chatbotlang: newlang });
      console.log(
        "%%%%%%==chatbot Language is updated and changed==%%%%%%",
        window.chatbotlang
      );
    }
  }

  render() {
    if (this.state.bottom === undefined) {
      return null;
    }

    const isArabic = this.state.chatbotlang === "ar";
    const isMOID = config.company === "MOID";
    const isMobile = window.innerWidth < 601;

    // تحديد وصف الوصول (لقارئات الشاشة)
    let ariaLabel = isArabic ? "اسأل عادل" : "Ask Adel";
    if (isMOID) {
      ariaLabel = isArabic ? "الدردشة مع الفطين" : "Chat with Alfateen";
    }
return (
  <div
    className={
      isArabic || config.company === "MOJ"
        ? "infoSt-badge"
        : "infoSt-badge-right"
    }
    style={{ bottom: `${this.state.bottom}px` }}
    onClick={this.props.onClick} // ← أعد إضافته هنا
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (this.props.onClick) {
          this.props.onClick(e);
        }
      }
    }}
    tabIndex="0"
    role="button"
    aria-label={ariaLabel}
  >
    {isMOID ? (
      <img
        alt=""
        src={
          (config.cssJsHostPublic || "") +
          `/chatbotinfost/webchat_images/${
            isArabic ? "AlFateenAvatar__.gif" : "Avatar-GIF-ENG.gif"
          }`
        }
        className="infoSt-fateen infoSt-envelope-top"
      />
    ) : isMobile ? (
      <div className="infoSt-adel-mobile maad-bot">
        <p aria-hidden="true">{isArabic ? "اسأل عادل" : "Ask Adel"}</p>
      </div>
    ) : (
      <img
        alt=""
        src={
          (config.cssJsHostPublic || "") +
          `/chatbotinfost/webchat_images/${isArabic ? "ad.gif" : "ad-EN-2.gif"}`
        }
        className="infoSt-envelope infoSt-envelope-top"
      />
    )}
  </div>
);
  }
}

export default Badge;